import type { VoucherConfiguration } from '#src/interfaces/voucherConfiguration'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useVoucherConfigStore = defineStore('voucherConfigStore', () => {
  const voucherConfig = ref<VoucherConfiguration | null>(null)

  const setVoucherConfig = (config: VoucherConfiguration) => {
    voucherConfig.value = config
  }

  return {
    voucherConfig,
    setVoucherConfig
  }
})
